import React from 'react';
import styled from 'styled-components';
import { H1, SectionParent, B1, BlueButton } from '../../StyledComponents';
import { navigate } from 'gatsby';
import RV from '../../../assets/avd/shipping.svg';
import RC from '../../../assets/avd/accelerate.svg';
import RD from '../../../assets/avd/field.svg';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const Section = styled(SectionParent)`
  background: #fafcff;
  display: grid;
  /* z-index: 0; */
  position: relative;
  @media (max-width: 768px) {
    padding-bottom: 0rem;
  }
  @media (max-width: 700px) {
    padding-bottom: 0rem;
  }
`;

export const PageTitle = styled(H1)`
  color: #4a5376;

  line-height: 1.28;
  justify-self: center;
  text-align: center;
  margin-top: 3rem;
  margin-bottom: 2rem;
  /* font-weight: 600; */
  @media (max-width: 768px) {
    margin-bottom: 2rem;
    margin-top: 2rem;
  }
  @media (max-width: 550px) {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
  @media (max-width: 520px) {
    font-size: 24px;
  }
`;
const Container = styled.div`
  justify-content: center;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding-left: 5%;
  padding-right: 5%;
  padding-bottom: 3rem;
  @media (max-width: 1100px) {
    padding-left: 0%;
    padding-right: 0%;
  }
  @media (max-width: 520px) {
    grid-template-columns: repeat(1, 1fr);
    padding-left: 0%;
    padding-bottom: 0;
    padding-right: 0%;
  }
`;

const Item = styled.div`
  display: grid;
  justify-items: center;

  @media (max-width: 520px) {
    margin-bottom: 3rem;
  }
`;
const BlueButtonWrapper = styled.div`
  /* margin-top: -6rem; */
  justify-content: center;
  display: flex;
  margin-bottom: 2rem;
  @media (max-width: 768px) {
    justify-self: center;
    margin-top: 0;
  }
`;
const ItemImg = styled(LazyLoadImage)`
  height: 92px;
`;

const ItemText = styled(B1)`
  margin-top: 1rem;
  text-align: center;
  padding: 0 3rem;
  min-height: 6rem;
  font-family: 'Nunito Sans', sans-serif;
  color: #26315c;
  font-weight: bold;
`;

export default () => (
  <div>
    <Section>
      <PageTitle>Benefits of Custom AVD</PageTitle>
      <Container>
        <Item>
          <ItemImg src={RV} />
          <ItemText>
            Reduce shipping cost of actual hardware by testing them with Esper’s
            Android Virtual Device
          </ItemText>
        </Item>
        <Item>
          <ItemImg src={RC} />
          <ItemText>
            Grow your ISV developer base by providing custom device emulators to
            kickstart app development instantaneously
          </ItemText>
        </Item>
        <Item>
          <ItemImg src={RD} />
          <ItemText>
            Test app-device compatibility right from the development phase using
            a custom emulator
          </ItemText>
        </Item>
      </Container>
      <BlueButtonWrapper>
        <BlueButton
          id="avd__try_it_now"
          onClick={() => navigate('/signup')}
          style={{
            marginLeft: '0',
            backgroundColor: '#725cbd',
            textTransform: 'none',
          }}
        >
          Try it now
        </BlueButton>
      </BlueButtonWrapper>
    </Section>
  </div>
);
